module.exports = __webpack_public_path__ + "static/img/17a.87a47ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17a.jpg
// module id = 6W2d
// module chunks = 0